import { useEffect, useState } from 'react';

import { useIdleTimer } from 'react-idle-timer';

import storageWrapper from 'common/loginUtils/storage-wrapper';

export default function useLogoutIdleTimer(props: {
	logoutIdelTime: number;
	callOnLogout: () => void;
}) {
	const [timeOut, setTimeOut] = useState<number>();

	const timer = useIdleTimer({
		timeout: timeOut,
		onIdle: () => {
			const res = storageWrapper.getStorageItem('loginState') || false;
			if (res) {
				props.callOnLogout();
			}
		},
		crossTab: true,
		onAction: () => {
			setTimeOut(props?.logoutIdelTime);
		},
	});

	const logoutOnIdle = () => timer;
	useEffect(() => {
		setTimeOut(props?.logoutIdelTime);
	}, []);
	return {
		logoutOnIdle,
	};
}
